import { Component, Input } from '@angular/core';
import { RouteTreeChartRowDto } from '../RouteTreeChartRowDto';

@Component({
  selector: 'shared-route-chart-row',
  templateUrl: './shared.route.chart.row.component.html',
  styleUrls: ['./shared.route.chart.row.component.scss'],
})
export class SharedRouteChartRowComponent {

  @Input() value: RouteTreeChartRowDto;

  public pretty(value: any): string {
    return JSON.stringify(value, null, 2);
  }

}
